import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import {
  Spin,
  Tabs,
} from 'antd';
import {
  notificationsAtom,
  myCommissionsHeaderAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';
import MyCommissionsTable from './MyCommissionsTable';

function MyCommissionsSection({ type }) {
  const { t } = useTranslation();
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const [selectedTab, setSelectedTab] = useState('paid');
  const [headerInfo, setHeaderInfo] = useRecoilState(myCommissionsHeaderAtom);
  const [hasPaid, setHasPaid] = useState(false);
  const [hasScheduled, setHasScheduled] = useState(false);
  const [hasNoDate, setHasNoDate] = useState(null);

  function getHeader() {
    api.post('reports/compensation/me', {
      page: 0,
      size: 0,
      filter: type
    })
    .then((response) => {
      if (response.data.success) {
        setHeaderInfo(response.data.data);
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response?.data?.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error?.message,
          error: true,
        },
      ]);
    })
  }

  useEffect(() => {
    setSelectedTab('paid');
    getHeader();
  }, []);

  useEffect(() => {
    const tempHasPaid = headerInfo?.paidCount > 0;
    const tempHasScheduled = headerInfo?.scheduledCount > 0;
    const tempHasNoDate = headerInfo?.noDateCount > 0
    setHasPaid(tempHasPaid);
    setHasScheduled(tempHasScheduled);
    setHasNoDate(tempHasNoDate);
    if (tempHasPaid) {
      setSelectedTab('paid');
    } else if (!tempHasPaid && tempHasScheduled) {
      setSelectedTab('scheduled');
    } else if (!tempHasPaid && !tempHasScheduled && tempHasNoDate) {
      setSelectedTab('nodate');
    } else {
      setSelectedTab('paid');
    }
  }, [headerInfo]);

  return (
    <div>
      <Spin spinning={!headerInfo}>
        <Tabs activeKey={selectedTab} onChange={(obj) => setSelectedTab(obj)}>
          <Tabs.TabPane disabled={!hasPaid} tab={hasPaid ? `${t('paid')} (${headerInfo?.paidCount})` : t('paid')} key="paid">
          <MyCommissionsTable filter={type === 0 ? 0 : 1} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={!hasScheduled} tab={hasScheduled ? `${t('scheduled')} (${headerInfo?.scheduledCount})` : t('scheduled')} key="scheduled">
          <MyCommissionsTable filter={type === 0 ? 2 : 3} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={!hasNoDate} tab={hasNoDate ? `${t('no_payout_date')} (${headerInfo?.noDateCount})` : t('no_payout_date')} key="nodate">
            <MyCommissionsTable filter={type === 0 ? 4 : 5} />
          </Tabs.TabPane>
        </Tabs>
      </Spin>
    </div>
   );
}

export default MyCommissionsSection;
